import { css } from '../../styles/theme';
import { rem } from 'polished';
import { IButtonStyles } from '../Button/ButtonStyled';

export const StylesAP = css<IButtonStyles>`
    width: 100%;
    padding: ${rem(16)} ${rem(20)};
    
    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.white};
        `}
    
    
    ${({ primary }) =>
        primary &&
        css`
            &:hover {
                background-color: ${({ theme }) => theme.colors.primaryBlack};
            }
        `}
    
    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            color: ${({ theme }) => theme.colors.white};
            border: 1px solid ${({ theme }) => theme.colors.default};
        `}

`;
